    <div class="confirmation-card">
        <div class='confirmation-details'>
            <div class='summary-heading'>{{ getAppointmentSummaryMsg(appointment?.appointmentType, appointment?.appointmentStatus,appointment?.emailAddress) }}</div>
            <div class="summary-details"
                *ngFor="let item of getDetailKeys()"
                [ngStyle]="{'display': view == 'confirm' ? 'grid' : 'block'}">
                <div
                class='key'
                [ngStyle]="{'padding': view == 'confirm' ? '1rem' : '0rem'}">{{item | translate}}</div>
                <div
                class='value'
                [ngStyle]="{'padding': view == 'confirm' ? '1rem' : '0rem', 'font-weight': item === 'service.time' && view == 'confirm' ?
                'bold' : ''}">{{getTranslation(item)}}
                    <asp-icon name="ic-20-feedback-info.svg" *ngIf="item == 'Coupons'"></asp-icon>
                    <div *ngIf="view == 'confirm' && item == 'Coupons'" class='coupon'>
                        <div class='coupon-warning'>
                            <asp-icon name="ic-20-feedback-alert-error.svg"></asp-icon>
                            {{ 'testDrive.mustBringCouponsToAppointment' | translate}}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="view == 'confirm' && !signedIn" class="create-account">
                {{ 'testDrive.saveAndBookAppointmentsQuickly' | translate}}
                <a class="create-link" href="{{registerUrl}}" target="blank">{{ 'service.createAnAccount' | translate}}</a>
                <asp-icon name="ic-20-arrow-half-right.svg"></asp-icon>
            </div>
            <div *ngIf="appointment?.appointmentStatus !== 'SavedForLater'">
            <div *ngIf="view == 'confirm'" class="d-flex">
                <!-- Disabled class should be removed after reschedule flow for delivery appointment is implemented -->
                <div class='cancel-edit' (click)="onEdit()">{{ 'testDrive.editAppointment' | translate}}</div>
                <div class='cancel-edit' (click)="onCancel()">{{ 'testDrive.cancelAppointment' | translate}}</div>
            </div>
            </div>
            <div *ngIf="view == 'confirm' && signedIn && returnTo == 'bdc-dashboard'">
                <div class='cancel-edit manage' (click)="onManage('asp/bdc/dashboard')">{{ (appointment?.appointmentStatus === 'SavedForLater') ? ('scheduleRotation.backToCustomerDashboard' | translate) : ('testDrive.viewAndManageAppointments' | translate)}}</div>
            </div>
            <div *ngIf="view == 'confirm' && signedIn && returnTo == 'service-dashboard'">
                <div class='manage' (click)="onManage('asp/service/scheduledashboard')">{{ 'service.returnToDashboard' | translate}}</div>
            </div>
            <div *ngIf="view == 'confirm'" class='dealer-details'>
              <a [href]="'tel:' + (dealerPhone$ | async)">
                <asp-icon name="phone-dialer-solid.svg" width="1.2rem"></asp-icon>
                <span class="dealer-info">{{ (dealerName$ | async) + ' • ' + ((dealerPhone$ | async) | phone) }}</span>
              </a>
            </div>
        </div>

    </div>
